import type { ConversationsTableDensity } from '../../../../../../conversationsTable.types';

import styles from './conversationsTablePreferencesDensityPreview.module.scss';

const width = 88;
const height = 32;
const borderWidth = 1.5;

export type ConversationsTablePreferencesDensityPreviewProps = {
  /** The density the preview shows. */
  density: ConversationsTableDensity;
};

/** A miniature of the conversations table with its rows at the given density. */
export const ConversationsTablePreferencesDensityPreview = ({
  density,
}: ConversationsTablePreferencesDensityPreviewProps): JSX.Element => {
  const rowCount = density === 'compact' ? 3 : 2;
  // The rows share the space inside the outline and between the dividers.
  const rowHeight = (height - borderWidth * (rowCount + 1)) / rowCount;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      aria-hidden
    >
      <rect
        className={styles.frame}
        x={borderWidth / 2}
        y={borderWidth / 2}
        width={width - borderWidth}
        height={height - borderWidth}
        rx={2}
        strokeWidth={borderWidth}
      />

      {Array.from({ length: rowCount }, (_, index) => {
        const top = borderWidth + index * (rowHeight + borderWidth);
        const middle = top + rowHeight / 2;

        return (
          <g key={index}>
            {index > 0 && (
              <rect
                className={styles.content}
                x={borderWidth}
                y={top - borderWidth}
                width={width - borderWidth * 2}
                height={borderWidth}
              />
            )}
            <rect
              className={styles.content}
              x={7}
              y={middle - 2.5}
              width={5}
              height={5}
              rx={1}
            />
            <rect
              className={styles.content}
              x={18}
              y={middle - 1}
              width={62}
              height={2}
              rx={1}
            />
          </g>
        );
      })}
    </svg>
  );
};
